// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const plataformasFullfilledReducer = makeSetReducer(['plataformas/fullfilled']);

